var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v(" "+_vm._s(_vm.$t('salesInstallments'))+" ")]),(_vm.$parent.item.stat == 1 && _vm.$checkRole('sales_payments_add'))?_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":'/salesInstallments/create?customer_id=' + _vm.$route.params.id}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('Addition'))+" ")]):_vm._e()],1),_c('indexTable',{attrs:{"searchText":_vm.$t('FindAInstallment'),"withoutCard":true,"emptyTableText":_vm.$parent.$t('there Are No sales Installments'),"filter":{ customer_id: _vm.$route.params.id },"emptyTableSubText":_vm.$parent.$t('Try adding some items to the table and try again'),"cloumns":[
        {
          column: 'code',
          title: _vm.$t('Payment'),
          type: 'mainLink',
          sort: true
        },
        {
          column: 'customer_id',
          title: _vm.$t('Customer name'),
          type: 'link',
          to: 'customer',
          sort: true,
          link: true
        },
        {
          column: 'created_date',
          title: _vm.$t('RegistrationDate'),
          type: 'text',
          sort: true
        },
        {
          column: 'date',
          title: _vm.$parent.$t('Payment date'),
          type: 'text',
          sort: true
        },
        {
          column: 'description',
          title: _vm.$parent.$t('Thats about'),
          type: 'text',
          sort: true
        },
        {
          column: 'total',
          title: _vm.$parent.$t('Amount'),
          type: 'text',
          sort: true
        },
        {
          column: 'paid',
          title: _vm.$t('Paid'),
          type: 'text',
          sort: true
        },
        {
          column: 'stat',
          title: _vm.$t('Active'),
          type: 'status',
          sort: true,
          values: [
            {
              title: _vm.$t('Waiting'),
              value: 1,
              color: 'info'
            },
            {
              title: _vm.$t('Driven'),
              value: 0,
              color: 'success'
            }
          ]
        },
        {
          column: 'options',
          title: _vm.$parent.$t('Settings'),
          type: 'options',
          options: [
            { name: 'show' },
            {
              name: 'edit',
              role: _vm.$checkRole('sales_cheques_edit')
            },
            {
              name: 'link',
              role: _vm.$checkRole('sales_cheques_edit'),
              title: _vm.$t('AddPayment'),
              icon: 'dollar-sign',
              link: '/salesInstallmentsPayments/create/'
            },
            {
              name: 'delete',
              role: _vm.$checkRole('sales_cheques_delete')
            }
          ]
        }
      ],"deleteText":{
        attention: _vm.$parent.$t('Attention'),
        areYouReallySureToDeleteTheItem: _vm.$parent.$t('Are you really sure to delete the item'),
        close: _vm.$parent.$t('Close'),
        confirm: _vm.$parent.$t('Confirm'),
        loading: _vm.$parent.$t('Loading')
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }